import {
  fetchDeals,
  fetchDealsCount,
  fetchDealSlug,
} from "../../services/deals";
import { action, thunk } from "easy-peasy";

export const dealModel = {
  deals: [],
  chosenDeal: {},
  totalCount: 0,
  pageNumber: 1,
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setDeals: action((state, payload) => {
    state.deals = payload;
  }),
  setTotalCount: action((state, payload) => {
    state.totalCount = payload;
  }),
  setPageNumber: action((state, payload) => {
    state.pageNumber = payload;
  }),
  setDeal: action((state, payload) => {
    state.chosenDeal = payload;
  }),
  getDealSlug: thunk(async (actions, payload) => {
    try {
      const request = await fetchDealSlug(payload);
      if (request && !request.error && request.length > 0)
        actions.setDeal(request[0]);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getDeals: thunk(async (actions, payload) => {
    try {
      const request = await fetchDeals(payload);
      if (request && !request.error) actions.setDeals(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getDealsCount: thunk(async (actions, payload) => {
    try {
      const request = await fetchDealsCount(payload);
      if (request && !request.error) actions.setTotalCount(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
